import { create, useModal } from "@ebay/nice-modal-react";
import { useTranslation } from "react-i18next";
import { canv } from "@/canv/global";
import { Button } from "@/shared/ui/Button";
import { VStack } from "@/shared/ui/Stack";
import { Modal } from "../../Modal/Modal";
import styles from "./BuyProModal.module.css";
import {
    BUY_PRO_MODAL_BUTTON_TRANSLATION_KEY,
    BUY_PRO_MODAL_IMAGE_URL,
    BUY_PRO_MODAL_TEXT_BY_FEATURE,
    type BuyProModalFeature,
} from "./constants";

type BuyProModalProps = {
    feature: BuyProModalFeature;
    teamId?: string;
};

const BuyProModal = create<BuyProModalProps>(function BuyProModal({ feature, teamId }) {
    const { t } = useTranslation();
    const { resolve, hide, remove } = useModal();
    const { titleKey, descriptionKey } = BUY_PRO_MODAL_TEXT_BY_FEATURE[feature];

    const handleClose = () => {
        resolve();
        hide();
        remove();
    };

    const handleUpgradeButtonClick = () => {
        const currentTeamId = teamId || canv.getInitDataProp("teamId");
        if (!currentTeamId) return;

        window.open(
            `${canv.host}/dashboard?need_tariff_payment=true&teamId=${currentTeamId}`,
            "_blank",
        );
    };

    return (
        <Modal onClose={handleClose}>
            <VStack gap={24}>
                <VStack gap={16} fullWidth>
                    <span className={styles.imageWrapper}>
                        <img
                            className={styles.image}
                            src={`${canv.host}${BUY_PRO_MODAL_IMAGE_URL}`}
                            alt=""
                        />
                    </span>

                    <h2 className={styles.title}>{t(titleKey)}</h2>

                    <p className={styles.text}>{t(descriptionKey)}</p>
                </VStack>

                <Button fullWidth onClick={handleUpgradeButtonClick}>
                    {t(BUY_PRO_MODAL_BUTTON_TRANSLATION_KEY)}
                </Button>
            </VStack>
        </Modal>
    );
});

export { BuyProModal };
export type { BuyProModalFeature };
